import getDevice from '@clearscore/helpers.device';

const device = getDevice();

export default {
    cs_site: '@market.activeMarket',
    score_band: '?@dashboard.data.creditReportInfo.scoreBand',
    device,
};
